module.exports = __webpack_public_path__ + "static/media/BricolageGrotesque-SemiBold.5c513f7e.woff2";